import type React from 'react';

export function MobileListCard({ children, onClick }: { children: React.ReactNode; onClick?: () => void }) {
  return (
    <section className={`mobile-list-card ${onClick ? 'clickable' : ''}`} onClick={onClick}>
      {children}
    </section>
  );
}
